import Service from "./Service";
import { orderService } from "./orderService";

class trafficService extends orderService {
  GetSimpleOrder(id: string) {
    return this.get<any>(`/TrafficOrder/GetSimpleOrder?UniqueID=${id}`);
  }
}

export default new trafficService("traffic", "TrafficOrder");
